import { collection, query, where, getCountFromServer, Timestamp, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import db from '../firebase';

export const getArticleCountsByDay = async (daysToAnalyze = 250) => {
    const articlesRef = collection(db, 'articles');
    const counts = [];

    try {
        // Get dates for analysis
        const dates = [...Array(daysToAnalyze)].map((_, index) => {
            const date = new Date();
            date.setDate(date.getDate() - index);
            return date;
        });

        // Get counts for each day
        for (const date of dates) {
            const startOfDay = new Date(date);
            startOfDay.setHours(0, 0, 0, 0);
            
            const endOfDay = new Date(date);
            endOfDay.setHours(23, 59, 59, 999);

            const q = query(
                articlesRef,
                where('pubDate', '>=', Timestamp.fromDate(startOfDay)),
                where('pubDate', '<=', Timestamp.fromDate(endOfDay))
            );

            const snapshot = await getCountFromServer(q);
            
            counts.push({
                date: startOfDay.toISOString().split('T')[0],
                count: snapshot.data().count
            });
        }

        return counts;

    } catch (error) {
        console.error('Error counting articles by day:', error);
        throw error;
    }
};

export const saveArticleCounts = async (counts) => {
    try {
        await setDoc(doc(db, 'metadata', 'articleCounts'), {
            lastUpdated: serverTimestamp(),
            dailyCounts: counts,
        });
    } catch (error) {
        console.error('Error saving article counts:', error);
        throw error;
    }
};

export const updateArticleCountStats = async () => {
    try {
        const counts = await getArticleCountsByDay();
        await saveArticleCounts(counts);
        return true;
    } catch (error) {
        console.error('Error updating article count stats:', error);
        return false;
    }
};